<template>
  <div>
    <Search
      :title="$lang.term_register_code_list"
      :allowFields="$lang.profileLang.term_register_code_fields"
      :hiddenFields="hiddenFields"
      :url="url"
      :showAlert="true"
      :titleAlert="topAlertMessage"
      colorAlert="info"
      :allowCollapse="false"
      :visibleSearch="true"
      :visibleSettings="true"
      :visibleExport="true"
      :visibleFilters="true"
      :visibleViewCount="true"
      :allowEdit="false"
      :filterCatch="true"
      :showTotals="true"
      :openNewTab="true"
      routeName="survey_group_edit"
      removeModalSize="lg"
      :defaultViewCount="10"
      :dynamicButtons="dynamicButtons"
      primaryKey="id"
      ref="termState"
      :visibleAdd="isAdmin(permissions, ['admin'])"
      :isImportExcel="true"
      :isImportExcelTooltip="$lang.import_excel_register_code"
      :otherExportExcelParams="{ term_code: this.code }"
      @importExcel="showUploadCardModal"
      @getPermisson="updatePermissions"
      @getOther="getOther"
    >
      <template slot="addModal" slot-scope="search">
        <AddTermRegisterCode
          :code="code"
          @close="search.close"
          @getData="getData"
        />
      </template>
    </Search>
    <b-modal
      no-close-on-backdrop
      variant="primary"
      header-bg-variant="primary"
      content-class="border-primary"
      v-model="cardUploadModal"
      size="xl"
      ok-only
      hide-footer
      hide-header
    >
      <b-card>
        <div slot="header">
          <strong v-text="$lang.import_excel_register_code" />
        </div>
        <ShowCardUpload
          :url="uploadExcelUrl"
          :showAlert="exampleFileLink"
          @closeModal="cardUploadModal = false"
          @getItems="getData"
        />
      </b-card>
    </b-modal>
  </div>
</template>

<script>
import Search from "@/components/base/search";
import ShowCardUpload from "@/components/fileManager/showCardUpload";
import { pathOr, includes } from "ramda";
import AddTermRegisterCode from "./addTermRegisterCode.vue";
import { isAdmin, generateApiUrl } from "@/shared/utils";

export default {
  name: "register-code-manager",
  components: {
    Search,
    AddTermRegisterCode,
    ShowCardUpload,
  },
  data() {
    return {
      code: this.$route.params.code,
      dynamicButtons: [
        {
          id: "52",
          name: "termRegisterCodeDelete",
        },
      ],
      permissions: [],
      hiddenFields: ["created_by", "created_at.jalali"],
      otherData: null,
      cardUploadModal: false,
    };
  },
  computed: {
    url() {
      return generateApiUrl(["profile", "term_register_code"], [this.code], {
        term_code: this.code,
      });
    },
    topAlertMessage() {
      const termCaption = pathOr(null, ["term_caption"], this.otherData);
      return termCaption
        ? `لیست کدهای ثبت نام در دوره <span class="text-primary font-weight-bold">${termCaption}</span>`
        : "";
    },
    uploadExcelUrl() {
      return generateApiUrl(
        ["profile", "import_term_register_code"],
        [this.code]
      );
    },
    exampleFileLink() {
      const link = `${generateApiUrl(["resources", "upload_folder"], [], {}, [
        "server_url",
      ])}/import_term_register_code_sample.xlsx`;
      return `<div class='text-center font-weight-bold'><a href='${link}'>جهت دانلود فایل نمونه کلیک کنید</a></div>`;
    },
  },
  methods: {
    pathOr,
    includes,
    isAdmin,
    generateApiUrl,
    getData() {
      this.$refs.termState.getItems();
    },
    updatePermissions(data) {
      this.permissions = data;
    },
    getOther(data) {
      this.otherData = data;
    },
    goToEditTermState(item) {
      this.$router.push({
        name: "edit_term_state",
        params: {
          term_code: this.code,
          term_state_code: pathOr(null, ["code"], item),
        },
      });
    },
    showUploadCardModal() {
      this.cardUploadModal = true;
    },
  },
};
</script>
